/*
 * Chatwidget Adeqo: de weergave rond window.SupportChat (client.js van support.godu.nl).
 * Markup en teksten: snippets/adeqo-support-chat.liquid. Contract: ~/Code/support/docs/webchat-thema.md.
 *
 * De knop verschijnt pas als chat.init() gelukt is. Staat de widget op de server (nog) niet aan, dan
 * blijft alles verborgen en merkt de bezoeker niets.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-adeqo-chat]');
  if (!root || !window.SupportChat) return;

  /* Teksten uit | t zijn HTML-ge-escaped (&#39;, &amp;); wij tonen ze met textContent, dus eerst terug naar tekst. */
  function decode(value) {
    if (typeof value === 'string') {
      return value.indexOf('&') < 0 ? value : new DOMParser().parseFromString(value, 'text/html').documentElement.textContent;
    }
    if (Array.isArray(value)) return value.map(decode);
    if (value && typeof value === 'object') {
      var out = {};
      Object.keys(value).forEach(function (k) { out[k] = decode(value[k]); });
      return out;
    }
    return value;
  }

  var cfg = decode(JSON.parse(root.querySelector('[data-adeqo-chat-config]').textContent));
  var t = cfg.t;
  var q = function (name) { return root.querySelector('[data-chat-' + name + ']'); };
  var panel = q('panel'), launcher = q('launcher'), launcherText = q('launcher-text'), badge = q('badge');
  var scroller = q('scroll'), list = q('messages'), input = q('input'), sendBtn = q('send');
  var emailBox = q('email'), emailForm = q('email-form'), emailError = q('email-error'), emailSubmit = q('email-submit');
  var emailInput = emailForm.elements.email;
  var identity = window.supportChatIdentity || null;
  var SS_OPEN = 'adeqo-chat:open', SS_DRAFT = 'adeqo-chat:draft';

  var chat = window.SupportChat.create({
    widget: cfg.widget,
    identity: identity && { email: identity.email, timestamp: identity.timestamp, signature: identity.signature },
    context: function () { return { page: location.href, product: cfg.product || undefined }; },
  });

  var opened = false, gate = false, busy = false, state = chat.getState();

  function session(key, value) {
    try {
      if (value === undefined) return sessionStorage.getItem(key);
      if (value === null) sessionStorage.removeItem(key);
      else sessionStorage.setItem(key, value);
    } catch (e) { /* geen opslag: de chat werkt, maar onthoudt dit niet */ }
    return null;
  }

  function icon(name) {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('aria-hidden', 'true');
    var use = document.createElementNS(ns, 'use');
    use.setAttribute('href', '#adeqo-chat-i-' + name);
    svg.appendChild(use);
    return svg;
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  /* Tekst blijft tekst; alleen https-links worden klikbaar. */
  function linkify(text) {
    var p = el('p');
    String(text || '').split(/(https:\/\/[^\s<>"]+)/).forEach(function (part, i) {
      if (i % 2) {
        var a = el('a', null, part);
        a.href = part;
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        p.appendChild(a);
      } else if (part) {
        p.appendChild(document.createTextNode(part));
      }
    });
    return p;
  }

  function time(iso) {
    try {
      return new Date(iso).toLocaleTimeString(cfg.locale, { hour: '2-digit', minute: '2-digit' });
    } catch (e) { return ''; }
  }

  function setStatus(text) {
    var s = q('status');
    s.textContent = text || '';
    s.hidden = !text;
  }

  /* ---------- Starttoestand: kop, intro en suggesties ---------- */

  function renderStarters(starters) {
    var box = q('suggestions');
    box.replaceChildren();
    starters.forEach(function (s) {
      var b = el('button', 'adeqo-chat__suggestion');
      b.type = 'button';
      b.append(icon(s.icon), el('span', null, s.label), icon('diagonal'));
      b.addEventListener('click', function () {
        if (input.value.trim()) {
          setStatus(t.draft_kept);
          input.focus();
          return;
        }
        input.value = s.draft || s.label;
        updateInput();
        input.focus();
        input.setSelectionRange(input.value.length, input.value.length);
      });
      box.appendChild(b);
    });
  }

  function useGeneralTopic() {
    var h = q('title');
    h.replaceChildren();
    cfg.general.title.split('\n').forEach(function (line, i) {
      if (i) h.appendChild(el('br'));
      h.appendChild(document.createTextNode(line));
    });
    q('intro').textContent = cfg.general.intro;
    renderStarters(cfg.general.starters);
    cfg.product = null;
    var strip = q('context');
    if (strip) strip.remove();
  }

  /* ---------- Gesprek ---------- */

  function renderMessage(m) {
    var li = el('li', 'adeqo-chat__msg adeqo-chat__msg--' + (m.from === 'team' ? 'team' : 'visitor'));
    if (m.status === 'sending') li.classList.add('is-sending');
    if (m.status === 'failed') li.classList.add('is-failed');
    if (m.from === 'team') li.appendChild(el('span', 'adeqo-chat__meta adeqo-chat__meta--top', m.name || t.team_fallback));
    li.appendChild(linkify(m.text));
    if (m.attachments && m.attachments.length) {
      m.attachments.forEach(function (a) { li.appendChild(el('span', 'adeqo-chat__meta', a.name)); });
    }
    var meta;
    if (m.status === 'sending') meta = t.sending;
    else if (m.status === 'failed') meta = t.failed + (cfg.locale === 'nl' && m.error ? ': ' + m.error : '');
    else meta = time(m.at);
    li.appendChild(el('span', 'adeqo-chat__meta adeqo-chat__meta--bottom', meta));
    if (m.status === 'failed') {
      var actions = el('div', 'adeqo-chat__msg-actions');
      var retry = el('button', null, t.retry);
      retry.type = 'button';
      retry.addEventListener('click', function () { chat.retry(m.id).catch(function () {}); });
      var discard = el('button', null, t.discard);
      discard.type = 'button';
      discard.addEventListener('click', function () { chat.discard(m.id); });
      actions.append(retry, discard);
      li.appendChild(actions);
    }
    return li;
  }

  function nearBottom() {
    return scroller.scrollHeight - scroller.scrollTop - scroller.clientHeight < 80;
  }

  function scrollDown() {
    requestAnimationFrame(function () { scroller.scrollTop = scroller.scrollHeight; });
  }

  function render(next) {
    var stick = nearBottom();
    var grew = next.messages.length > state.messages.length;
    state = next;
    var msgs = state.messages;
    var started = msgs.length > 0;

    list.replaceChildren.apply(list, msgs.map(renderMessage));

    var last = msgs[msgs.length - 1];
    var waiting = started && last.from === 'visitor' && last.status !== 'failed' && !msgs.some(function (m) { return m.from === 'team'; });
    q('waiting').hidden = !waiting;
    q('expectation').textContent = state.config && state.config.open ? t.expectation_open : t.expectation_closed;

    q('offline').hidden = state.connection !== 'offline';
    q('welcome').hidden = started || gate;
    q('suggestions').hidden = started || gate;
    q('team').hidden = started || gate;
    var strip = q('context');
    if (strip) strip.hidden = started;
    if (started) {
      input.placeholder = t.placeholder_chat;
      q('note').textContent = t.note_chat;
    }

    launcherText.textContent = started ? t.launcher_continue : t.launcher;
    launcher.setAttribute('aria-label', (started ? t.launcher_continue : t.launcher) + (state.unread ? '. ' + t.unread : ''));
    badge.hidden = !state.unread;
    badge.textContent = state.unread || '';

    if (grew && (stick || (last && last.from === 'visitor'))) scrollDown();
  }

  /* ---------- Invoer en versturen ---------- */

  function updateInput() {
    // Alleen meten als het paneel zichtbaar is; verborgen is scrollHeight 0.
    if (!panel.hidden) {
      input.style.height = '40px';
      input.style.height = Math.min(96, input.scrollHeight) + 'px';
    }
    sendBtn.disabled = gate || busy || !input.value.trim();
    session(SS_DRAFT, input.value ? input.value : null);
  }

  function deliver(text) {
    input.value = '';
    updateInput();
    setStatus('');
    chat.send(text).catch(function () { /* staat als mislukt bericht in de lijst, met Opnieuw */ });
    input.focus();
  }

  function send() {
    var text = input.value.trim();
    if (!text || busy) return;
    if (gate) { emailInput.focus(); return; }
    if (state.contact) { deliver(text); return; }
    if (identity && identity.email) { startConversation(identity.email, identity.name || ''); return; }
    openGate();
  }

  function errorText(err) {
    if (err && err.code === 'network') return t.network_error;
    if (err && err.code === 'invalid_input') return t.email_invalid;
    return cfg.locale === 'nl' && err && err.message ? err.message : t.error_generic;
  }

  function startConversation(email, name) {
    busy = true;
    emailSubmit.disabled = true;
    updateInput();
    chat.start({ name: name, email: email, website: emailForm.elements.website.value })
      .then(function () {
        busy = false;
        closeGate(false);
        var text = input.value.trim();
        if (text) deliver(text);
      })
      .catch(function (err) {
        busy = false;
        updateInput();
        if (!gate) openGate();
        showEmailError(errorText(err));
      })
      .then(function () { emailSubmit.disabled = false; });
  }

  function showEmailError(text) {
    emailError.textContent = text || '';
    emailError.hidden = !text;
    emailInput.setAttribute('aria-invalid', String(!!text));
    if (text) emailInput.focus();
  }

  function openGate() {
    gate = true;
    emailBox.hidden = false;
    if (!emailInput.value && identity && identity.email) emailInput.value = identity.email;
    showEmailError('');
    render(state);
    updateInput();
    requestAnimationFrame(function () { emailInput.focus({ preventScroll: true }); scroller.scrollTop = 0; });
  }

  function closeGate(focusInput) {
    gate = false;
    emailBox.hidden = true;
    showEmailError('');
    render(state);
    updateInput();
    if (focusInput !== false) input.focus();
  }

  emailForm.addEventListener('submit', function (e) {
    e.preventDefault();
    emailInput.value = emailInput.value.trim();
    if (!emailInput.value || !emailInput.checkValidity()) { showEmailError(t.email_invalid); return; }
    if (!input.value.trim()) { closeGate(); return; }
    startConversation(emailInput.value, identity && identity.email === emailInput.value ? identity.name || '' : '');
  });
  emailInput.addEventListener('input', function () { showEmailError(''); });
  q('email-back').addEventListener('click', function () { closeGate(); });

  q('composer').addEventListener('submit', function (e) { e.preventDefault(); send(); });
  input.addEventListener('input', function () { setStatus(''); updateInput(); });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) { e.preventDefault(); send(); }
  });

  var dismiss = q('context-dismiss');
  if (dismiss) dismiss.addEventListener('click', function () { useGeneralTopic(); input.focus(); });

  /* ---------- Open en dicht ---------- */

  function setOpen(value, focus) {
    opened = value;
    panel.hidden = !opened;
    root.classList.toggle('is-open', opened);
    launcher.setAttribute('aria-expanded', String(opened));
    chat.setOpen(opened);
    session(SS_OPEN, opened ? '1' : null);
    if (opened) {
      updateInput();
      if (state.messages.length) scrollDown();
      else scroller.scrollTop = 0;
    }
    if (focus !== false) (opened ? (gate ? emailInput : input) : launcher).focus({ preventScroll: true });
  }

  launcher.addEventListener('click', function () { setOpen(!opened); });
  q('minimize').addEventListener('click', function () { setOpen(false); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && opened) setOpen(false);
  });

  /* ---------- Niet over de sticky balken heen ---------- */

  var bars = document.querySelectorAll('.adeqo-sticky-atc, .zk-sticky-cta');
  function lift() {
    var px = 0;
    bars.forEach(function (bar) {
      if (bar.classList.contains('is-visible')) px = Math.max(px, bar.offsetHeight + 12);
    });
    root.style.setProperty('--chat-lift', px + 'px');
  }
  if (bars.length) {
    var observer = new MutationObserver(lift);
    bars.forEach(function (bar) { observer.observe(bar, { attributes: true, attributeFilter: ['class'] }); });
    window.addEventListener('resize', lift);
    lift();
  }

  /* ---------- Start ---------- */

  renderStarters(cfg.starters);
  var draft = session(SS_DRAFT);
  if (draft) input.value = draft;
  updateInput();

  chat.on('change', render);
  chat.init().then(function (s) {
    render(s);
    launcher.hidden = false;
    if (session(SS_OPEN) === '1') setOpen(true, false);
  }).catch(function () {
    // Widget staat op de server niet aan of is onbereikbaar: niets tonen.
    root.hidden = true;
  });
})();
